import React from 'react'
import { useNavigate } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";

import {authenticationActions} from "../../actions/index";

import RecuperoDati from "./component/RecuperoDati";
import {LoadingOverlays} from "../../components";
import {getVersionBackEnd} from "../../actions/actions/__configAction"
import { isPwa } from '../../fanctionUtility';


const Home = () => {
    const navigate = useNavigate();

    const configurationFile = useSelector(state => state.configurationFile.fileConf);
    const backendVersion = useSelector((state) => state.configurationFile.versionBackend);
    const roles = useSelector(state => state.auth.profiliDisponibili)
    const token = useSelector(state => state.auth.token);
    const refreshToken = useSelector(state => state.auth.refreshToken);
    const expiresIn = useSelector(state => state.auth.exp);
    const dispatch = useDispatch();

    const recuperaGeneralita = React.useCallback((baseUrlAuthService) => dispatch(authenticationActions.recuperaGeneralita(baseUrlAuthService, navigate)), [dispatch]);
    const requestRefreshToken = React.useCallback((clientId, baseUrlAuthService, refreshToken, navigate) => dispatch(authenticationActions.requestRefreshToken(clientId, baseUrlAuthService, refreshToken, navigate)), [dispatch]);
    const salvaRuolo = React.useCallback((ruolo) => dispatch(authenticationActions.salvaRuolo(ruolo)), [dispatch]);
    const clearError = React.useCallback(() => dispatch(authenticationActions.clearError()), [dispatch]);
    const verificaRuoli = React.useCallback(() => dispatch(authenticationActions.verificaRuoli()), [dispatch]);

    React.useEffect(() => {
        let refreshTimeoutId;

        if (token != null) {
            recuperaGeneralita(configurationFile.baseUrlAuthService);
            refreshTimeoutId = setTimeout(() =>
                    requestRefreshToken(
                        configurationFile.clientId,
                        configurationFile.baseUrlAuthService,
                        refreshToken,
                        navigate),
                (expiresIn - 5) * 1000);

            if (roles.length === 0) {
                verificaRuoli()
            }
        }

        return () => {
            if (refreshTimeoutId) {
                clearTimeout(refreshTimeoutId);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        token,
    ]);

    React.useMemo(() => {
        if (!backendVersion) {
            dispatch(getVersionBackEnd())
        }
    }, [getVersionBackEnd, dispatch])


    const chooseRole = (e) => {
        salvaRuolo(e.target.value);
        if (isPwa()) {
            navigate("/corsi");
        }
    };

    return (
        <>
            <LoadingOverlays/>
            <RecuperoDati chooseRole={chooseRole}/>
        </>
    )

}

export default Home;
